import { render, staticRenderFns } from "./MovieInfo.vue?vue&type=template&id=4774c148&scoped=true"
import script from "./MovieInfo.vue?vue&type=script&lang=js"
export * from "./MovieInfo.vue?vue&type=script&lang=js"
import style0 from "./MovieInfo.vue?vue&type=style&index=0&id=4774c148&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4774c148",
  null
  
)

export default component.exports